import { LILI_SUPPORT_EMAIL, LILI_SUPPORT_PHONE } from '@Types/consts';
import logoUrl from '@Assets/logos/lili-logo-blue.svg';
import { FontWeight, Heading } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';

export interface SupportDetailsProps {
  shouldShowLogo?: boolean;
}

export const SupportDetails = ({ shouldShowLogo }: SupportDetailsProps) => {
  const { t } = useTranslation();
  return (
    <div className='flex-col'>
      {shouldShowLogo && <img className='w-[52px]' src={logoUrl} alt='Lili logo' />}
      <div className='flex flex-col mt-[16px] gap-[4px]'>
        <Heading.H10 fontWeight={FontWeight.SEMIBOLD}>
          {t('passwordlessSideMenu.customerService')}
        </Heading.H10>
        <Heading.H12>
          <a
            href={`mailto:${LILI_SUPPORT_EMAIL}`}
            target='_blank'
            className='text-text-brand-primary hover:text-text-brand-primary-hover'>
            {t('passwordlessSideMenu.emailOurTeam')}
          </a>
          {t('passwordlessSideMenu.callUs')}
        </Heading.H12>
        <Heading.H12>{LILI_SUPPORT_PHONE}</Heading.H12>
        <Heading.H12 className='pb-[24px] mb-[24px] border-b-[1px] border-b-outline-primary-bw-03 '>
          {t('passwordlessSideMenu.openHours')}
        </Heading.H12>
        <Heading.H12 className='text-text-main-disabled'>
          {t('passwordlessSideMenu.disclaimer')}
        </Heading.H12>
      </div>
    </div>
  );
};
